import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/index.vue'
import Login from '@/components/Login/'
import SignUp from '@/components/SignUp/'
import ForgotPassword from '@/components/ForgotPassword/'
import PrivacyPolicy from '@/components/PublicPages/PrivacyPolicy.vue'
import i18n from '@/i18n'

// import { cfirebase } from '../services/firebase.js'

import HomeRoutes from './home'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: HomeRoutes,
    redirect: 'Dashboard',
    meta: {requiresAuth: true}
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/signup',
    name: 'SignUp',
    component: SignUp
  }, {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  }, {
    path: '*',
    redirect: '/'
  } , {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
]

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  // const uid = window.localStorage.getItem('user')
  // let user = cfirebase.auth().currentUser
  let user = window.localStorage.getItem('user')
  let brand = window.localStorage.getItem('brand')
  let locale = window.localStorage.getItem("locale");
  if(locale) {
    i18n.locale = locale;
  }
  if(to.name == 'Login' || to.name == 'SignUp') {
    const loader = document.getElementsByClassName('app-loader');
    // loader[0].remove();
    if(loader && loader.length) {
      // loader[0].remove();
      setTimeout(() => {
       loader[0].remove();
      }, 7000);
    }
  }
  if (to.meta.requiresAuth) {
    if (user && brand) {
      next()
    } else {
      next({name: 'Login'})
    }
  } else {
    if (user && brand) {
      next('/')
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js